// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraSerif_ee8d01', '__fedraSerif_Fallback_ee8d01'"},"className":"__className_ee8d01","variable":"__variable_ee8d01"};